import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { Link } from 'react-router-dom';
import { Breadcrumb } from "./common/Breadcrumb";

interface State {
}

export default class Home extends React.Component<RouteComponentProps<{}>, State> {
    constructor(props: RouteComponentProps<{}>) {
        super(props);

        this.state = {

        };
    }

    public render() {
        const isDevelopment = HostingEnv === "development" || HostingEnv === "qa";
        const isProduction = HostingEnv === "staging" || HostingEnv === "production";

        return <div className="container-fluid">
            <div className="animated fadeIn">
                <Breadcrumb />
                <div className="button-group">
                    <Link to="/quotes/add" className="button__item"><i className="icon-quotes-black"></i>Create Quote</Link>

                    {
                        BQS && isDevelopment &&
                        <a href="https://businesscentral.dynamics.com/659cf46c-6db7-4abb-8f6e-a8dbf5816da1/Sandbox/?company=Brent%20Material&page=21&mode=create" target="_blank" rel="noopener noreferrer" className="button__item">Add Customers</a>
                    }
                    {
                        BQS && isProduction &&
                        <a href="https://businesscentral.dynamics.com/659cf46c-6db7-4abb-8f6e-a8dbf5816da1/Production/?company=Brent%20Material&page=21&mode=create" target="_blank" rel="noopener noreferrer" className="button__item">Add Customers</a>
                    }

                    {
                        BQS && isDevelopment &&
                        <a href="https://businesscentral.dynamics.com/659cf46c-6db7-4abb-8f6e-a8dbf5816da1/Sandbox/?company=Brent%20Material&page=30&mode=create" target="_blank" rel="noopener noreferrer" className="button__item">Add Items</a>
                    }
                    {
                        BQS && isProduction &&
                        <a href="https://businesscentral.dynamics.com/659cf46c-6db7-4abb-8f6e-a8dbf5816da1/Production/?company=Brent%20Material&page=30&mode=create" target="_blank" rel="noopener noreferrer" className="button__item">Add Items</a>
                    }

                    {
                        BQS && isDevelopment &&
                        <a href="https://businesscentral.dynamics.com/659cf46c-6db7-4abb-8f6e-a8dbf5816da1/Sandbox/?company=Brent%20Material&page=5733&mode=create" target="_blank" rel="noopener noreferrer" className="button__item">Add Categories</a>
                    }
                    {
                        BQS && isProduction &&
                        <a href="https://businesscentral.dynamics.com/659cf46c-6db7-4abb-8f6e-a8dbf5816da1/Production/?company=Brent%20Material&page=5733&mode=create" target="_blank" rel="noopener noreferrer" className="button__item">Add Categories</a>
                    }

                    {
                        BQS && isDevelopment &&
                        <a href="https://businesscentral.dynamics.com/659cf46c-6db7-4abb-8f6e-a8dbf5816da1/Sandbox/?company=Brent%20Material&page=26&mode=create" target="_blank" rel="noopener noreferrer" className="button__item">Add Vendors</a>
                    }
                    {
                        BQS && isProduction &&
                        <a href="https://businesscentral.dynamics.com/659cf46c-6db7-4abb-8f6e-a8dbf5816da1/Production/?company=Brent%20Material&page=26&mode=create" target="_blank" rel="noopener noreferrer" className="button__item">Add Vendors</a>
                    }

                    {/*CQS*/}
                    {
                        CQS && isDevelopment &&
                        <a href="https://businesscentral.dynamics.com/659cf46c-6db7-4abb-8f6e-a8dbf5816da1/Sandbox/?company=Caterina%20Supply&page=21&mode=create" target="_blank" rel="noopener noreferrer" className="button__item">Add Customers</a>
                    }
                    {
                        CQS && isProduction &&
                        <a href="https://businesscentral.dynamics.com/659cf46c-6db7-4abb-8f6e-a8dbf5816da1/Production/?company=Caterina%20Supply&page=21&mode=create" target="_blank" rel="noopener noreferrer" className="button__item">Add Customers</a>
                    }

                    {
                        CQS && isDevelopment &&
                        <a href="https://businesscentral.dynamics.com/659cf46c-6db7-4abb-8f6e-a8dbf5816da1/Sandbox/?company=Caterina%20Supply&page=30&mode=create" target="_blank" rel="noopener noreferrer" className="button__item">Add Items</a>
                    }
                    {
                        CQS && isProduction &&
                        <a href="https://businesscentral.dynamics.com/659cf46c-6db7-4abb-8f6e-a8dbf5816da1/Production/?company=Caterina%20Supply&page=30&mode=create" target="_blank" rel="noopener noreferrer" className="button__item">Add Items</a>
                    }

                    {
                        CQS && isDevelopment &&
                        <a href="https://businesscentral.dynamics.com/659cf46c-6db7-4abb-8f6e-a8dbf5816da1/Sandbox/?company=Caterina%20Supply&page=5733&mode=create" target="_blank" rel="noopener noreferrer" className="button__item">Add Categories</a>
                    }
                    {
                        CQS && isProduction &&
                        <a href="https://businesscentral.dynamics.com/659cf46c-6db7-4abb-8f6e-a8dbf5816da1/Production/?company=Caterina%20Supply&page=5733&mode=create" target="_blank" rel="noopener noreferrer" className="button__item">Add Categories</a>
                    }

                    {
                        CQS && isDevelopment &&
                        <a href="https://businesscentral.dynamics.com/659cf46c-6db7-4abb-8f6e-a8dbf5816da1/Sandbox/?company=Caterina%20Supply&page=26&mode=create" target="_blank" rel="noopener noreferrer" className="button__item">Add Vendors</a>
                    }
                    {
                        CQS && isProduction &&
                        <a href="https://businesscentral.dynamics.com/659cf46c-6db7-4abb-8f6e-a8dbf5816da1/Production/?company=Caterina%20Supply&page=26&mode=create" target="_blank" rel="noopener noreferrer" className="button__item">Add Vendors</a>
                    }

                    <Link to="/reports" className="button__item"><i className="icon-reports-black"></i>Reports</Link>

                </div>
            </div>
        </div>;
    }

    public componentDidMount() {
        document.title = "Dashboard - " + SITE_NAME;
    }
}



// WEBPACK FOOTER //
// ./ClientApp/components/Home.tsx